import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Layout } from '../layout';
const Content = styled(Layout.Content)`
  padding: 0 var(--layout-02);

  .ant-tabs,
  .ant-menu-horizontal {
    margin: 0 calc(-1 * var(--layout-02));
  }

  .ant-menu-horizontal {
    padding: 0 var(--layout-01);
  }

  .ant-tabs > .ant-tabs-nav {
    background: var(--coolest-gray-10);
    margin: 0;
  }

  .ant-tabs > .ant-tabs-nav,
  .ant-tabs > .ant-tabs-content-holder {
    padding: 0 var(--layout-01);
  }
`;
export const ContentShell = ({ children })=>/*#__PURE__*/ _jsx(Content, {
        children: children
    });
